import { OkrSession, OkrObjective, OkrKeyResult } from "server/models"
import { inferLiteral, OrderType } from "client/utils"
import * as types from "./types"


export const setOkrObjectiveBaseRoute = (baseRoute: string) => ({
    type: inferLiteral(types.OKR_OBJECTIVE_BASE_ROUTE),
    baseRoute,
})
export const setOkrObjectiveRoute = (objectiveRoute: string) => ({
    type: inferLiteral(types.OKR_OBJECTIVE_ROUTE),
    objectiveRoute,
})


export const setOkrObjectiveList = (objectiveList: types.OkrObjectiveList) => ({
    type: inferLiteral(types.OKR_OBJECTIVE_LIST),
    objectiveList,
})
export const setOkrObjectiveIds = (objectiveIds: number[]) => ({
    type: inferLiteral(types.OKR_OBJECTIVE_IDS),
    objectiveIds,
})
export const setOkrObjectiveEdit = (objective: OkrObjective) => ({
    type: inferLiteral(types.OKR_OBJECTIVE_EDIT),
    objective,
})


// to select parent
export const setOkrObjectiveAvailableSessions = (sessions: OkrSession[]) => ({
    type: inferLiteral(types.OKR_OBJECTIVE_AVAILABLE_SESSIONS),
    sessions,
})
export const setOkrObjectiveAvailableObjectives = (objectives: { [sessionId: number]: OkrObjective[] }) => ({
    type: inferLiteral(types.OKR_OBJECTIVE_AVAILABLE_OBJECTIVES),
    objectives,
})
export const setOkrObjectiveAvailableKeyResults = (keyResults: { [sessionId: number]: OkrKeyResult[] }) => ({
    type: inferLiteral(types.OKR_OBJECTIVE_AVAILABLE_KEY_RESULTS),
    keyResults,
})


export const setOkrObjectiveSort = (sortColumn: keyof OkrObjective, sortOrder: OrderType) => ({
    type: inferLiteral(types.OKR_OBJECTIVE_SORT),
    sortColumn,
    sortOrder,
})
export const setOkrObjectiveFilters = (filters: types.OkrObjectiveFilters) => ({
    type: inferLiteral(types.OKR_OBJECTIVE_FILTERS),
    filters,
})


// popup menu
export const setOkrObjectiveActive = (active: OkrObjective) => ({
    type: inferLiteral(types.OKR_OBJECTIVE_ACTIVE),
    active,
})
export const setOkrObjectivePopupMenuShow = (show: boolean) => ({
    type: inferLiteral(types.OKR_OBJECTIVE_POPUP_MENU_SHOW),
    show,
})
export const setOkrObjectivePopupMenuTarget = (target: HTMLElement) => ({
    type: inferLiteral(types.OKR_OBJECTIVE_POPUP_MENU_TARGET),
    target,
})
export const setOkrObjectiveShowConfirmDelete = (show: boolean) => ({
    type: inferLiteral(types.OKR_OBJECTIVE_SHOW_CONFIRM_DELETE),
    show,
})


export const setOkrObjectiveReloadList = (value: boolean) => ({
    type: inferLiteral(types.OKR_OBJECTIVE_RELOAD_LIST),
    value,
})
export const setOkrObjectiveReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.OKR_OBJECTIVE_RELOAD_EDIT),
    value,
})
